import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-update",
  "use": "icon-update-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-update\"><defs><style type=\"text/css\"></style></defs><path d=\"M296.541091 821.108364l-0.325818 0.372363-170.589091 6.050909 6.050909-170.635636 0.325818-0.325818 164.538182 164.538182zM767.394909 350.254545l-405.038545 405.038546-164.538182-164.538182 405.038545-405.038545 164.538182 164.538181z m164.584727-164.538181l-98.722909 98.676363-164.584727-164.538182L767.394909 21.178182l164.584727 164.538182zM115.293091 907.636364H929.838545v93.090909H115.293091z\" p-id=\"12814\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/update.svg
// module id = U60a
// module chunks = 58